module.exports = __webpack_public_path__ + "static/media/ThumbnailStill10.8a050d4c.png";